import { Capacitor } from '@capacitor/core';
import { getFirestore, initializeFirestore } from 'firebase/firestore';

let cachedDb = null;
let cachedForApp = null;

/**
 * Firestore for the given FirebaseApp. On Capacitor iOS/Android, default WebChannel
 * transport can leave getDoc/onSnapshot pending forever in WKWebView; force long polling.
 * @see https://firebase.google.com/docs/firestore/manage-data/internet-poor-environments
 */
export function getSharedFirestore(firebaseApp) {
  if (!firebaseApp) return null;
  if (cachedDb && cachedForApp === firebaseApp) return cachedDb;

  if (Capacitor.isNativePlatform()) {
    try {
      // In recent SDKs, auto-detect long-polling can default to true. Explicitly set it false
      // when forcing long polling to avoid settings conflicts that can silently fall back.
      cachedDb = initializeFirestore(firebaseApp, {
        experimentalForceLongPolling: true,
        experimentalAutoDetectLongPolling: false,
        useFetchStreams: false,
      });
    } catch (e) {
      const msg = String(e?.message || e || '');
      if (e?.code === 'failed-precondition' || msg.includes('already')) {
        cachedDb = getFirestore(firebaseApp);
      } else {
        console.warn('[firestoreClient] initializeFirestore failed, falling back to getFirestore:', e);
        cachedDb = getFirestore(firebaseApp);
      }
    }
  } else {
    cachedDb = getFirestore(firebaseApp);
  }
  cachedForApp = firebaseApp;
  return cachedDb;
}
